import React from "react";
import { Badge } from "./Badge";

// `danger` + `checkedLabel` are for the toggles where ON is the restrictive choice (blocking a
// ticket provider): green-ish primary reads as "all good" there, which is exactly backwards.
// `trailing` takes any extra control the row owns (the provider category picker), so a row with
// a second input does not have to re-implement the switch.
function ToggleSwitch({
  label,
  labelHref,
  description,
  checked,
  disabled,
  danger,
  checkedLabel,
  trailing,
  onToggle,
}) {
  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border border-border p-3">
      <div className="min-w-0">
        {/* `truncate`, not `break-words`: a long provider id has no spaces, so wrapping it broke
            one letter per line. Only the label truncates — descriptions still wrap in full. */}
        <p className="truncate text-sm font-medium" title={typeof label === "string" ? label : undefined}>
          {labelHref ? (
            <a href={labelHref} target="_blank" rel="noopener noreferrer" className="hover:underline">
              {label}
            </a>
          ) : (
            label
          )}
        </p>
        <p className="text-xs text-muted-foreground">{description}</p>
      </div>
      <div className="flex flex-shrink-0 items-center gap-2">
        {trailing}
        {checked && checkedLabel ? (
          <Badge variant={danger ? "destructive" : "default"}>{checkedLabel}</Badge>
        ) : null}
        <button
          type="button"
          role="switch"
          aria-checked={!!checked}
          aria-label={`Toggle ${label}`}
          disabled={disabled}
          onClick={onToggle}
          className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors disabled:opacity-50 ${
            checked ? (danger ? "bg-destructive" : "bg-primary") : "bg-muted"
          }`}
        >
          <span
            className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${
              checked ? "translate-x-5" : "translate-x-1"
            }`}
          />
        </button>
      </div>
    </div>
  );
}

export { ToggleSwitch };
